import { Component, Injector } from '@angular/core';
import type { OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { ViewBasePage } from '@shared/pages';
import { Constants } from '@shared/models';

@Component({
    'selector': 'app-version',
    'templateUrl': './version.page.html',
    'styleUrls': ['./version.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class VersionPage extends ViewBasePage implements OnInit {
    public vm: any = {};

    constructor(injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_VERSION);
    }

    public override ngOnInit(): void {
        const domainInfo = this.utilsService.getDomainInfo();

        this.vm.version = Constants.APPLICATION_VERSION;
        this.vm.releaseDate = Constants.APPLICATION_RELEASE_DATE;
        this.vm.domain = domainInfo.properOrigin;
        this.initMoreMenu();
    }

    public initMoreMenu(): void {
        // this.resetPopoverMenu();
        // this.pushPopoverMenuItem('Show Tour', 'show-version-tour');
    }
}
